import { useFormik } from "formik";
import * as Yup from "yup";
import { V3CaptionGrey48 } from "../../ReusableStyledComponents/V3CaptionGrey48";
import { VerticalSpacing } from "../../VerticalSpacing";
import { V3Button } from "../../Button";
import { RightAlignPanel } from "../../ReusableStyledComponents/RightAlignPanel";
import { V3ButtonColor } from "../../Button/V3Button.types";
import { V3TextArea } from "../../TextInput/V3TextInput";
import { useState, type JSX } from "react";
import { V3Loader } from "../../Loader";

interface SourceExistsForm {
    notes: string;
}

interface AddSourceExistsFormProps {
    onBackHandler: () => void;
    onSourceExistsSubmit: (notes: SourceExistsForm) => Promise<void>;
    description: string | JSX.Element;
    placeholder?: string;
}

export const AddSourceExistsForm = ({ onBackHandler, description, placeholder, onSourceExistsSubmit }: AddSourceExistsFormProps) => {
    const [submitting, setSubmitting] = useState(false);

    const formik = useFormik<SourceExistsForm>({
        initialValues: {
            notes: ""
        },
        onSubmit: async (data) => {
            try {
                setSubmitting(true);
                await onSourceExistsSubmit(data);
            } catch {}

            setSubmitting(false);
        },
        validationSchema: Yup.object().shape({
            notes: Yup.string().required("Please enter a reply")
        })
    });

    let error: string | undefined | JSX.Element =
        formik.errors.hasOwnProperty("notes") && formik.touched.hasOwnProperty("notes") ? formik.errors.notes : undefined;

    return (
        <>
            <VerticalSpacing bottom={28}>
                <V3CaptionGrey48>{description}</V3CaptionGrey48>
            </VerticalSpacing>
            <form onSubmit={formik.handleSubmit}>
                <VerticalSpacing bottom={24}>
                    <V3TextArea
                        style={{ minHeight: 150 }}
                        error={error}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.notes || ""}
                        name="notes"
                        placeholder={placeholder}
                        disabled={submitting}
                    />
                </VerticalSpacing>
                <RightAlignPanel style={{ alignItems: "center" }}>
                    <div>
                        <V3Button text="Back" autoWidth onClick={onBackHandler} color={V3ButtonColor.secondary} disabled={submitting} />
                    </div>
                    <div>{submitting ? <V3Loader /> : <V3Button text="Send" type="submit" autoWidth disabled={submitting} />}</div>
                </RightAlignPanel>
            </form>
        </>
    );
};
